export function getEmployeeLabel (employee) {
  if (employee.user !== undefined) {
    employee = employee.user
  }
  return ((employee.first_name || '') + ' ' + (employee.last_name || '')).trim()
}
